/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExternalImageMetadataPoseCenter } from './ExternalImageMetadataPoseCenter';
import {
    ExternalImageMetadataPoseCenterFromJSON,
    ExternalImageMetadataPoseCenterFromJSONTyped,
    ExternalImageMetadataPoseCenterToJSON,
} from './ExternalImageMetadataPoseCenter';
import type { ExternalImageMetadataPoseRotation } from './ExternalImageMetadataPoseRotation';
import {
    ExternalImageMetadataPoseRotationFromJSON,
    ExternalImageMetadataPoseRotationFromJSONTyped,
    ExternalImageMetadataPoseRotationToJSON,
} from './ExternalImageMetadataPoseRotation';

/**
 * 
 * @export
 * @interface ExternalImageMetadataPose
 */
export interface ExternalImageMetadataPose {
    /**
     * 
     * @type {ExternalImageMetadataPoseCenter}
     * @memberof ExternalImageMetadataPose
     */
    center: ExternalImageMetadataPoseCenter;
    /**
     * 
     * @type {ExternalImageMetadataPoseRotation}
     * @memberof ExternalImageMetadataPose
     */
    rotation: ExternalImageMetadataPoseRotation;
}

/**
 * Check if a given object implements the ExternalImageMetadataPose interface.
 */
export function instanceOfExternalImageMetadataPose(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "center" in value;
    isInstance = isInstance && "rotation" in value;

    return isInstance;
}

export function ExternalImageMetadataPoseFromJSON(json: any): ExternalImageMetadataPose {
    return ExternalImageMetadataPoseFromJSONTyped(json, false);
}

export function ExternalImageMetadataPoseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalImageMetadataPose {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'center': ExternalImageMetadataPoseCenterFromJSON(json['center']),
        'rotation': ExternalImageMetadataPoseRotationFromJSON(json['rotation']),
    };
}

export function ExternalImageMetadataPoseToJSON(value?: ExternalImageMetadataPose | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'center': ExternalImageMetadataPoseCenterToJSON(value.center),
        'rotation': ExternalImageMetadataPoseRotationToJSON(value.rotation),
    };
}

